import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SchedulingService} from '../scheduling.service';
import {
    DoctorListModel,
    PasteReschedule,
    WaitListViewModel
} from '../../../models/appointments/dataAppointmentWaitList.model';
import {AppointmentDialogComponent} from '../dialog/appointment-dialog/appointment-dialog.component';
import {AppointmentDialogDataModel} from '../models/appointment-dialog-data.model';
import {Globals} from '../../../globals';
import {DataAppointmentModel} from '../../../models/appointments/data-appointment.model';
import {UserService} from '../../../services/user.service';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';

@Component({
  standalone: false,
    selector: 'app-wait-list-dialog',
    templateUrl: './wait-list-dialog.component.html',
    styleUrls: ['./wait-list-dialog.component.scss']
})


export class WaitListDialogComponent {
    isLoading: boolean = true;
    waitList: WaitListViewModel[] = [];
    waitListFilter: WaitListViewModel[] = [];
    selectedApp: WaitListViewModel;
    DoctorList: DoctorListModel[] = [];
    selectedDoctor: DoctorListModel[] = [];

    private appointmentDialogData: AppointmentDialogDataModel = new AppointmentDialogDataModel();


    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private snackBar: MatSnackBar,
                private dialogRef: MatDialogRef<WaitListDialogComponent>,
                private schedulingService: SchedulingService,
                public globals: Globals,
                public dialog: MatDialog,
                private userService: UserService) {
    }

    ngOnInit(): void {
        this.schedulingService.getAppointmentWaitList().subscribe(result => {
            if (result) {
                this.waitListFilter = this.waitList = result;
                this.getListAllDoctors();
                this.isLoading = false;
            }
        });

        this.appointmentDialogData = this.data;
        this.appointmentDialogData.appointment = new DataAppointmentModel();
        this.userService.getUsers(this.globals.TDOCID).subscribe((res) => {
            this.appointmentDialogData.users = res;
        });
    }

    getListAllDoctors() {
        this.waitList.forEach(item => {
            const {DoctorId, Doctor_FullName} = item;
            // Check if the DoctorId already exists in DoctorList
            const doctorExists = this.DoctorList.some(existingDoctor => existingDoctor.DoctorId === DoctorId);

            // If the DoctorId doesn't exist, add the item to DoctorList
            if (!doctorExists) {
                this.DoctorList.push({DoctorId, Doctor_FullName});
            }
        });
    }

    PasteReschedule(appWaitList: WaitListViewModel) {
        this.globals.RescheduleAppointmentRequest = {
            AppointmentId: appWaitList.AppointmentId,
            Patient_FullName: appWaitList.Patient_FullName,
            Reschedule_Note: appWaitList.Description
        };
        this.dialogRef.close(true);
    }


    ViewAppointment(appWaitList: WaitListViewModel) {
    // CHANGE TO CANCEL WITH DIALOG
        this.appointmentDialogData.isReadOnly = true;
        this.appointmentDialogData.appointment.AppointmentId = appWaitList.AppointmentId;
        this.appointmentDialogData.appointment.StartDate = appWaitList.StartDate.toString();
        this.appointmentDialogData.appointment.EndDate = appWaitList.EndDate.toString();
        this.appointmentDialogData.appointment.PatientCaseId = appWaitList.PatientCaseId;
        this.appointmentDialogData.appointment.CaseProcedureId = appWaitList.CaseProcedureId;
        this.appointmentDialogData.appointment.enumApptStatusId = appWaitList.enumApptStatusId;
        this.appointmentDialogData.appointment.enumApptTypeId = appWaitList.enumApptTypeId;
        this.appointmentDialogData.appointment.CaseWorkItemId = appWaitList.CaseWorkItemId;
        this.appointmentDialogData.appointment.PatientId = appWaitList.PatientId;
        this.appointmentDialogData.appointment.Label_DoctorId = appWaitList.Label_DoctorId;
        this.appointmentDialogData.appointment.Resource_OperatoryId = appWaitList.Resource_OperatoryId;
        this.appointmentDialogData.appointment.Subject = appWaitList.subject;
        this.appointmentDialogData.appointment.dataAppoitmentFlags = appWaitList.dataAppoitmentFlags;
        this.appointmentDialogData.appointment.dataAppoitmentDetails = appWaitList.dataAppoitmentDetails;

        this.appointmentDialogData.currentLocationId = this.globals.LOCID;

        const cancelConfig = new MatDialogConfig();
        cancelConfig.panelClass = 'dialog';
        cancelConfig.data = this.appointmentDialogData;
        cancelConfig.disableClose = true;
        this.dialog.open(AppointmentDialogComponent, cancelConfig).afterClosed().subscribe((res1) => {
            this.appointmentDialogData.isReadOnly = false;
        },
        (err) => {
            console.log('Error on subscribe', err);
        }
        );
    }

    onDoctorSelectionChange(event: TdoDropdownChange) {
        this.waitListFilter = [];
        this.selectedDoctor = event.value;
        for (const doctor of this.selectedDoctor) {
            this.waitListFilter = this.waitListFilter.concat(this.waitList.filter(a => a.DoctorId === doctor.DoctorId));
        }
    }

    onShowTasksChange(event: any) {
        switch (event.value) {
        case 'RD-ASC':
            this.waitListFilter.sort((b,a) => new Date(b.DateWaitListed).getTime() - new Date(a.DateWaitListed).getTime());
            break;
        case 'RD-DESC':
          this.waitListFilter.sort((a,b) => new Date(b.DateWaitListed).getTime() - new Date(a.DateWaitListed).getTime());
            break;
        case 'RF-ASC':
          this.waitListFilter.sort((b,a) => b.RefDoctor_FullName.localeCompare(a.RefDoctor_FullName));
            break;
        case 'RF-DESC':
          this.waitListFilter.sort((a,b) => b.RefDoctor_FullName.localeCompare(a.RefDoctor_FullName));
            break;
        }
    }

    onOk(){
        this.dialogRef.close(true);
    }
}
